import { ReactComponentManifest } from "web/entrypoints/common/setup";
import CollectionBar from "web/react/components/collection-bar/collection-bar";
import FeedControls from "web/react/components/feed-controls/feed-controls";
import FeedGenderSwitch from "web/react/components/feed-gender-switch/feed-gender-switch";
import FeedSwitchTabOverlay from "web/react/components/feed-switch-tab-overlay/feed-switch-tab-overlay";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FeedsShowMore from "web/react/components/feeds-show-more/feeds-show-more";
import FilterContainer from "web/react/components/filter-container/filter-container";
import Footer from "web/react/components/footer/footer";
import ClassicFooter from "web/react/components/classic-footer/classic-footer";
import ProfileHeader from "web/react/components/profile-header/profile-header";
import RelatedRail from "web/react/components/related-rail/related-rail";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    CollectionBar,
    FeedControls: withRedux(FeedControls),
    FeedGenderSwitch: withRedux(FeedGenderSwitch),
    FeedSwitchTabOverlay,
    FeedsSeoContent,
    FeedsShowMore: withRedux(FeedsShowMore),
    FilterContainer: withRedux(FilterContainer),
    Footer,
    ClassicFooter,
    ProfileHeader,
    RelatedRail,
    RelatedSearchesRail,
};

export default components;
